
export type DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory = typeof DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory[keyof typeof DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory = {
  TOPIC: 'TOPIC',
  TWEET: 'TWEET',
  USER: 'USER',
  PROJECT: 'PROJECT',
} as const;
